import { howItWorksSteps } from "@/mocks/categories";

export default function HowItWorks() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-semibold uppercase tracking-wider text-secondary-600 whitespace-nowrap">Process</span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-3">
            How Superbuy Spreadsheet Works
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Four simple steps to transform your shopping research from chaotic to systematic.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {howItWorksSteps.map((item, idx) => (
            <div key={idx} className="relative group">
              <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60 h-full">
                <span className="text-4xl md:text-5xl font-bold font-heading text-secondary-200 mb-3 block">
                  {item.step}
                </span>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
              </div>
              {idx < howItWorksSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 text-secondary-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}